module.exports = __webpack_public_path__ + "static/media/LeftMirror.1f5db66f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StandAlone/LeftMirror.png
// module id = 326
// module chunks = 0